import React, { useState } from 'react';

const FormCurl = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',             // ✅ Agregado este campo
    full_number: '',
    course_id: '',
    category_id: '',
    course: '',
    comment: '',
    country_code: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('/api/enviar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.text();
      console.log('Respuesta del servidor:', result);
      alert('Formulario enviado correctamente');
    } catch (error) {
      console.error('Error al enviar:', error);
      alert('Hubo un error al enviar el formulario');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <input name="name" placeholder="Nombre" onChange={handleChange} /><br />
      <input name="email" placeholder="Email" onChange={handleChange} /><br />
      <input name="full_number" placeholder="Teléfono completo" onChange={handleChange} /><br />
      <input name="course_id" placeholder="ID del curso" onChange={handleChange} /><br />
      <input name="category_id" placeholder="ID de categoría" onChange={handleChange} /><br />
      <input name="course" placeholder="Nombre del curso" onChange={handleChange} /><br />
      <textarea name="comment" placeholder="Comentario" onChange={handleChange}></textarea><br />
      <input name="country_code" placeholder="Código de país" onChange={handleChange} /><br />
      <button type="submit">Enviar</button>
    </form>
  );
};

export default FormCurl;
